export const APP_CONFIGURATION = {
  externals: {
    quoter: {
      load_quotation: false,
      redirection: true,
      redirection_path: "products",
      redirection_url: false,
      age_groups: {
        age_1: 38,
        age_2: 75,
      },
      seo: {
        btn_cta_quote: "btn-cotizar",
      },
    },
  },
};